import React from 'react';
import { useLang, LANGUAGES } from '../i18n/LanguageContext';

/**
 * LanguageToggle, EN · AR · DE · ES
 * Used in the global Header and in the ChoiceHero strip.
 *
 * Props:
 *   variant: 'header' | 'strip', surface treatment
 *   compact: boolean, drop separators on tight layouts
 */
const LanguageToggle = ({ variant = 'header', compact = false, onDark: onDarkProp = false }) => {
  const { lang, setLang } = useLang();
  const onDark = onDarkProp || variant === 'strip' || variant === 'footer';

  const baseColor = onDark ? 'rgba(214,168,122,0.75)' : '#D6A87A';
  const activeColor = onDark ? '#F4EFE3' : '#D6A87A';

  return (
    <div
      className="inline-flex items-center"
      data-testid={`lang-toggle-${variant}`}
    >
      {LANGUAGES.map((code, idx) => {
        const isActive = lang === code;
        return (
          <React.Fragment key={code}>
            <button
              type="button"
              onClick={() => setLang(code)}
              data-testid={`lang-btn-${code.toLowerCase()}`}
              aria-label={`Switch to ${code}`}
              className={`transition-all duration-200 ${compact ? 'mx-1' : ''}`}
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '10pt',
                fontWeight: 500,
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
                color: isActive ? activeColor : baseColor,
                borderBottom: isActive
                  ? `1px solid ${activeColor}`
                  : '1px solid transparent',
                paddingBottom: '2px',
                background: 'transparent',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.letterSpacing = '0.24em';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.letterSpacing = '0.22em';
              }}
            >
              {code}
            </button>
            {!compact && idx < LANGUAGES.length - 1 && (
              <span
                aria-hidden="true"
                className="mx-2 select-none"
                style={{ color: 'rgba(214,168,122,0.45)' }}
              >
                ·
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LanguageToggle;
